import React from "react";
import './styles/featurecardleft.css'

const FeatureCardLeft = ({ icon, title, description, bgColor, borderColor }) => {
  return (
    <div className="feature-card-left" style={{ border: `1px solid ${borderColor}` }}>
    <div className="feature-icon-left" style={{ background: bgColor }}>
      <img src={icon} alt="Feature Icon" />
    </div>
    <div className="feature-content-left">
      <h3 className="feature-title-left">{title}</h3>
      <p className="feature-description-left">{description}</p>
    </div>
  </div>
  );
};

export default FeatureCardLeft;